import { useEffect, useLayoutEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import HomePage from "./pages/HomePage";
import MapPage from "./pages/MapPage";
import CategoryPage from "./pages/CategoryPage";
import CategoriesPage from "./pages/CategoriesPage";
import IntersectionPage from "./pages/IntersectionPage.jsx";
import PostPage from "./pages/PostPage";
import NotFoundPage from "./pages/NotFoundPage";
import Philosophy from "./pages/Philosophy";
import DebordZine from "./pages/zines/DebordZine/DebordZine";
import HyperNecropolis from "./pages/Essays/HyperNecropolis";
import "./styles/global.css";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
};

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route path="map" element={<MapPage />} />
          <Route path="philosophy" element={<Philosophy />} />
          <Route path="zines/debord" element={<DebordZine />} />
          <Route path="essays/hyper-necropolis" element={<HyperNecropolis />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/category/:categoryId" element={<CategoryPage />} />
          <Route path="intersection/:intersectionId" element={<IntersectionPage />} />
          <Route path="/post/:postSlug" element={<PostPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;